import { useCallback, useEffect, useState } from "react";
import {
  MENU_FAVORITES_EVENT,
  menuFavoritesKey,
  parseMenuFavorites,
  toggleMenuFavorite,
} from "./menuGroups";

const read = (key: string): string[] => {
  try {
    return parseMenuFavorites(localStorage.getItem(key));
  } catch {
    return [];
  }
};

// Igual que las apps favoritas: por usuario y navegador, comodidad de quien usa
// la pantalla. Sin localStorage la estrella funciona sólo en esta vista.
export function useMenuFavorites(scope: string): {
  favorites: string[];
  toggle: (id: string) => void;
} {
  let userId: string | null = null;
  try {
    userId = localStorage.getItem("userId");
  } catch {
    userId = null;
  }
  const key = menuFavoritesKey(scope, userId);
  const [favorites, setFavorites] = useState<string[]>(() => read(key));

  useEffect(() => {
    setFavorites(read(key));
    const sync = () => setFavorites(read(key));
    const onStorage = (e: StorageEvent) => e.key === key && sync();
    window.addEventListener(MENU_FAVORITES_EVENT, sync);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(MENU_FAVORITES_EVENT, sync);
      window.removeEventListener("storage", onStorage);
    };
  }, [key]);

  const toggle = useCallback(
    (id: string) => {
      const next = toggleMenuFavorite(read(key), id);
      setFavorites(next);
      try {
        localStorage.setItem(key, JSON.stringify(next));
      } catch {
        /* sin almacenamiento: vale sólo para esta vista */
      }
      window.dispatchEvent(new Event(MENU_FAVORITES_EVENT));
    },
    [key],
  );

  return { favorites, toggle };
}
